export default __webpack_public_path__ + "static/media/pp.7a002de0.PNG";